import TogetherCounter from '../components/TogetherCounter';
import { Bague, CorseWord, FunfactTag, KoWord } from '../components/HistoireEggs';
import './NotreHistoire.css';

const TAGS = ['Funfact', 'Avril', 'Septembre', 'Novembre'];

function Coeur() {
  return (
    <svg className="icone-coeur" viewBox="0 0 24 24" aria-label="cœur" role="img">
      <path d="M12 21s-7.5-4.6-10-9.3C.3 8.2 2.3 4 6.2 4c2.2 0 3.8 1.3 4.8 2.8C12 5.3 13.6 4 15.8 4c3.9 0 5.9 4.2 4.2 7.7C19.5 16.4 12 21 12 21z" />
    </svg>
  );
}

const PLACEHOLDERS = {
  count: TogetherCounter,
  coeur: Coeur,
};

// Mots cliquables (easter eggs) repérés directement dans les textes.
const MOTS_SECRETS = {
  KO: KoWord,
  Corse: CorseWord,
  '💍': Bague,
};

function renderCount(text) {
  return text.split(/(\{\{\w+\}\}|\bKO\b|\bCorse\b|💍)/u).map((part, i) => {
    if (i % 2 === 0) {
      return part;
    }
    const placeholder = part.match(/^\{\{(\w+)\}\}$/)?.[1];
    const Component = placeholder ? PLACEHOLDERS[placeholder] : MOTS_SECRETS[part];
    return Component ? <Component key={i} /> : part;
  });
}

function renderTexte(texte) {
  return texte
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const tag = TAGS.find((t) => line.startsWith(t));
      if (!tag) {
        return <p key={line}>{renderCount(line)}</p>;
      }
      const reste = line.slice(tag.length).replace(/^\s*:\s*/, ' ').trim();
      return (
        <p key={line}>
          {tag === 'Funfact' ? (
            <FunfactTag>{tag}</FunfactTag>
          ) : (
            <span className="etape-tag">{tag}</span>
          )}{' '}
          {renderCount(reste)}
        </p>
      );
    });
}

const ETAPES = [
  {
    annee: '2016',
    titre: 'Notre rencontre',
    texte:
      'L\'ECCG de Martigny s\'en souvient encore\u00A0! Un couple star vient de naitre et déjoue tous les pronostics. Personne n\'avait parié que cette histoire allait durer {{count}} \nFunfact\u00A0: Le jour de l\'officialisation de leur couple, Hugo a mis Gabrielle KO lors d\'une balle au prisonnier avec un ballon en pleine tête.',
  },
  {
    annee: '2024',
    titre: 'Emménagement',
    texte:
      'Début de la vraie vie d\'adulte\u00A0! Apprendre à supporter les flasques de trail qui sèchent des jours à côté de l\'évier et la tonne de cheveux qui bouche la douche tous les 3 jours, débattre des heures sur le menu du souper et finir par manger des tortellini sauce tomate, mais surtout beaucoup de rires et d\'amour {{coeur}}',
  },
  {
    annee: '2025',
    titre: 'Bingo\u00A0!',
    texte:
      'Avril\u00A0: Adoption de Cisco, qui condamne Gabrielle et Hugo à avoir les mains qui sentent les croquettes et à retrouver des sacs à caca dans toutes leurs poches. \nSeptembre\u00A0: Les fiançailles\u00A0! Qui, malgré ce que tout le monde pense, étaient complètement inattendues pour Gabrielle. Seuls, perdus au milieu de la Corse, Gabrielle a dit oui 💍 \nNovembre\u00A0: Gabrielle et Hugo réalisent un de leurs rêves en achetant un VW California, pour aller n\'importe où, n\'importe quand.',
  },
  {
    annee: '2027',
    titre: 'Le mariage',
    texte: 'Le moment tant attendu, après plus de 10 ans. Célébrons cet amour {{coeur}} ',
  },
];

function NotreHistoire() {
  return (
    <div className="section container">
      <h1 className="section-title">Notre histoire</h1>
      <p className="section-subtitle">
        Quelques étapes de notre chemin jusqu'ici.
      </p>

      <div className="timeline">
        {ETAPES.map((etape, index) => (
          <div className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`} key={etape.titre}>
            <div className="timeline-card card">
              <span className="timeline-year">{etape.annee}</span>
              <h3>{etape.titre}</h3>
              <div className="timeline-text">{renderTexte(etape.texte)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default NotreHistoire;
